export const CustomerAccountReactivationEndpoints = {
  SEARCH_DEACTIVATED: '/api/admin/users/deactivated',
  REACTIVATE_USER: '/api/admin/users/:id/reactivate',
};
